import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { BProps, ICTSystemForService } from 'store/ducks/Reportings/types';
import { columnsICTSystemsByServices } from 'constants/reportColumns';
import { article8Op } from 'store/ducks/DataManagement/Article8AndICTSystem';

const ICTSystemsByServices: React.FC<BProps> = ({ entityName }) => {
  const { is_displayed, date } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<ICTSystemForService[]>([]);
  const dispatch = useDispatch();

  const flattenSystems = (systems: ICTSystemForService[]) => {
    const rows: any[] = [];

    systems.forEach((sys) => {
      const risks = sys.ict_risks?.length ? sys.ict_risks : [null];
      const dataItems = sys.data?.length ? sys.data : [null];

      risks.forEach((risk) => {
        dataItems.forEach((dataItem) => {
          rows.push({
            ...sys,
            _risk: risk,
            _data: dataItem,
          });
        });
      });
    });

    return rows;
  };

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    if (!entityName) return;

    const entityIds = entityName.split(',').map((id) => id.trim());

    try {
      const fetchedData = await article8Op.fetchICTSystemsDetailsByService(
        entityIds[0],
        date,
      );

      if (fetchedData && fetchedData.data.ict_systems) {
        const flat = flattenSystems(fetchedData.data.ict_systems);

        setData(flat);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching ict system by services:', error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [is_displayed, entityName]);

  return (
    <Table
      columns={columnsICTSystemsByServices}
      dataSource={data.map((item, idx) => ({ ...item, key: idx }))}
      scroll={{ x: 1000, y: 430 }}
    />
  );
};

export default ICTSystemsByServices;
